import React from 'react'

export default class ErrorMessage extends React.PureComponent {
    componentDidMount() {
        this.refs.errMsg.offsetParent.style.display = 'none'
    }

    render() {
        return(
            <span className="error-message" ref="errMsg"/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/messages/ErrorMessage.js